import { render, staticRenderFns } from "./TrainingServe.vue?vue&type=template&id=a2b8b80e&scoped=true&"
import script from "./TrainingServe.vue?vue&type=script&lang=js&"
export * from "./TrainingServe.vue?vue&type=script&lang=js&"
import style0 from "./TrainingServe.vue?vue&type=style&index=0&id=a2b8b80e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b8b80e",
  null
  
)

export default component.exports